import React from 'react';
import {RoleLabels, RoleName, RoleNames} from '../../../domain';
import {MultiMappingSelect} from './base/MultiMappingSelect';


type RoleOption = {
  value: RoleName;
  label: string;
};

const RoleOptions: RoleOption[] = RoleNames.map(name => (
  {
    value: name,
    label: RoleLabels[name]
  }
));

function getOptionValue(option: RoleOption) {
  return option.value;
}

function getOptionLabel(option: RoleOption) {
  return option.label;
}

type RolesSelectProps = {
  value: RoleName[];
  onChange: (roles: RoleName[]) => void;
  onBlur?: () => void;
};

export class RolesSelect extends React.Component<RolesSelectProps> {
  render() {
    return (
      <MultiMappingSelect<RoleOption, RoleName>
        options={RoleOptions}
        getValue={getOptionValue}
        getLabel={getOptionLabel}
        value={this.props.value}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}/>);
  }
}
